import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Enterprise-grade Spinner Component with Material UI
 * Full-screen loading spinner with optional text
 */
const Spinner = ({ className, text, size = 40, ...props }) => {
    return (
        <Box
            id="loader"
            className={className}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                width: "100%",
                position: "fixed",
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                zIndex: 9999,
            }}
            {...props}
        >
            <CircularProgress size={size} />
            {text && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2, textAlign: "center" }}
                >
                    {text}
                </Typography>
            )}
        </Box>
    );
};

Spinner.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    size: PropTypes.number,
};

export default Spinner;
